import { useEffect } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";

export default function SmoothScroll({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    // Core Web Vitals: lazy-load + async-decode all non-hero images automatically
    const optimize = (img) => {
      if (img.hasAttribute("data-hero")) {
        img.loading = "eager";
        img.setAttribute("fetchpriority", "high");
      } else if (!img.getAttribute("loading")) {
        img.loading = "lazy";
      }
      if (!img.getAttribute("decoding")) img.decoding = "async";
    };
    document.querySelectorAll("img").forEach(optimize);
    const observer = new MutationObserver((muts) => {
      muts.forEach((m) =>
        m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.tagName === "IMG") optimize(n);
          else n.querySelectorAll?.("img").forEach(optimize);
        })
      );
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children;
}
